type DebounceLeadingAsync<T> = (func: (...args: any[]) => Promise<T>, wait: number) => (...args: any[]) => Promise<T>;

export const debounceLeadingAsync: DebounceLeadingAsync<any> = (func, wait) => {
  let timeoutId: any = null;
  let lastInvokeTime: number | null = null;

  return async (...args: any[]) => {
    const now = Date.now();

    if (lastInvokeTime === null || now - lastInvokeTime > wait) {
      lastInvokeTime = now;
      await func(...args);
    } else {
      timeoutId && clearTimeout(timeoutId);

      timeoutId = setTimeout(async () => {
        lastInvokeTime = Date.now();
        timeoutId = null;
        await func(...args);
      }, wait);
    }
  };
};
